import { useEventListener } from '@vueuse/core';
import { useToast } from 'vue-toastification';

const TOAST_SELECTOR = '.Vue-Toastification__toast';
const TOAST_BODY_SELECTOR = '.Vue-Toastification__toast-body, .Vue-Toastification__toast-component-body';
const TOAST_ID_ATTRIBUTE = 'data-toast-id';
const INTERACTIVE_SELECTOR = 'a, button, [role="button"], input, select, textarea, label';

const findToast = (event: Event): HTMLElement | null => (
    event.target instanceof Element
        ? event.target.closest<HTMLElement>(TOAST_SELECTOR)
        : null
);

const findToastId = (toastElement: HTMLElement): number | null => {
    const rawId = toastElement
        .querySelector(`[${TOAST_ID_ATTRIBUTE}]`)
        ?.getAttribute(TOAST_ID_ATTRIBUTE);

    if (null === rawId || undefined === rawId) {
        return null;
    }

    const id = Number(rawId);

    return Number.isFinite(id) ? id : null;
};

const readToastText = (toastElement: HTMLElement): string => {
    const body = toastElement.querySelector<HTMLElement>(TOAST_BODY_SELECTOR) ?? toastElement;

    // innerText keeps the line break between the title and the message.
    const text = body.innerText ?? body.textContent ?? '';

    return text.replace(/\s+/g, ' ').trim();
};

const isInteractiveTarget = (event: Event): boolean => (
    event.target instanceof Element && null !== event.target.closest(INTERACTIVE_SELECTOR)
);

export const useToastInteractions = () => {
    const toast = useToast();

    useEventListener(document, 'contextmenu', (event) => {
        const toastElement = findToast(event);
        if (null === toastElement) {
            return;
        }

        event.preventDefault();

        const id = findToastId(toastElement);
        if (null === id) {
            return;
        }

        toast.dismiss(id);
    });

    useEventListener(document, 'click', (event) => {
        const toastElement = findToast(event);
        if (null === toastElement || isInteractiveTarget(event)) {
            return;
        }

        const text = readToastText(toastElement);
        if ('' === text) {
            return;
        }

        void navigator.clipboard?.writeText(text).catch(() => undefined);
    });
};
